export default "__VITE_ASSET__D7qpyhg5__"